<template>
  <v-container
    id="view-user-account"
    fluid
    v-if="loaded"
  >
    <v-row>
      <v-col cols="12">
        <h2>Account & Security</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="6">

        <ManagePassword></ManagePassword>

      </v-col>

      <v-col cols="12" lg="6">

        <ManageTwoFactor></ManageTwoFactor>

        <ManageNotifications></ManageNotifications>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ManagePassword from "@/views/user/components/ManagePassword";
import ManageTwoFactor from "@/views/user/components/ManageTwoFactor";
import ManageNotifications from "@/views/user/components/ManageNotifications.vue";

export default {
  name: "UserAccount",
  components: {
    ManageNotifications,
    ManagePassword,
    ManageTwoFactor
  },
  metaInfo () {
    return {
      title: "My Account"
    }
  },
  created() {
    this.$store.dispatch("loader/loaderCancel");
    this.fetchData();
  },
  data: () => ({
    loaded: false
  }),
  methods: {
    async fetchData() {
      await this.$store.dispatch("loader/loaderInitiate", {title: "Loading User Account"});

      await this.$store.dispatch("loader/loaderCancel");

      this.loaded = true;
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 0.9rem;
  color: #777;
  margin-top: 10px;
}

.two-factor {
  position: relative;

  .state {
    position: absolute;
    right:20px;
    top:20px;
  }

}

</style>
